// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"353":"contact","594":"about"}[chunkId] + "." + {"353":"956fd68b","594":"894d301b"}[chunkId] + ".css";
};